import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["item"];

  connect() {
    if (!this.hasItemTarget || !global.jQuery || !global.jQuery.fn.lightGallery) {
      return;
    }

    this.gallery = global.jQuery(this.element);
    this.gallery.lightGallery({
      selector: '[data-testimonial-gallery-target="item"]',
      thumbnail: false,
      download: false,
      share: false,
      rotate: false,
      hash: false,
      counter: true,
      controls: true,
      closable: true,
      loop: true,
      mousewheel: true,
      enableSwipe: true,
      enableDrag: true,
      actualSize: false,
      getCaptionFromTitleOrAlt: false,
    });
  }

  disconnect() {
    const instance = this.gallery && this.gallery.data("lightGallery");

    if (instance) {
      instance.destroy(true);
    }
  }
}
